module.exports = __webpack_public_path__ + "static/Entur_frontpage-23d1ed2391f51bb2f5c03932f995d6bb.jpg";